import { api } from '@ai/common/src/api/axios';
import type { AppConfig, SystemSettings } from '../../types/config';
import type { ExpertDefaults } from '../../types/expert';
import { widgetService } from '@ai/widget/src/api/services/widget.service';

const headers = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

class ConfigService {
  private baseUrl = '/platform/api/v1/config';

  getExpertConstants = async () =>
    await api.get<AppConfig<ExpertDefaults>>(
      `${widgetService.rootOrigin}${this.baseUrl}/expert_defaults`,
    );

  getSystemSettings = async () =>
    await api.get<AppConfig<SystemSettings>>(`${this.baseUrl}/system_settings`);

  getDefaultSystemSettings = async () =>
    await api.get<AppConfig<SystemSettings>>(`${this.baseUrl}/default_system_settings`);

  saveSystemSettings = async (body: SystemSettings) =>
    await api.post<AppConfig<SystemSettings>>(
      this.baseUrl,
      { type: 'system_settings', json: body },
      { headers },
    );

  getServiceEmail = async () =>
    await api.get<string>(`${widgetService.rootOrigin}${this.baseUrl}/google-service-email`);
}

export const configService = new ConfigService();
